<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="`Detail Tagihan`" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div class="f-16 f-regular f-c-black">
                    <label class="m-d-16 p-t-20 f-bold">{{ jenisTagihan }}</label>
                    <div class="register m-d-16" v-if="isRegister">
                        <div class="d-flex-between-center">
                            <label class="m-d-0">Registrasi nomor</label>
                            <label class="m-d-0">{{ tagihan.harga_registrasi | currency }}</label>
                        </div>
                        <div class="f-14 f-c-midgrey">
                            <label class="m-d-0 d-flex">+62 {{ tagihan.wa_device.number }}</label>
                            <label class="m-d-0 d-flex">{{ tagihan.wa_device.nama }}</label>
                        </div>
                    </div>
                    <div class="paket m-d-16">
                        <div class="d-flex-between-center">
                            <label class="m-d-0 paket-wa">{{ tagihan.wa_paket.nama }}</label>
                            <label class="m-d-0">{{ tagihan.harga_paket | currency }}</label>
                        </div>
                        <div class="f-14 f-c-midgrey">
                            <label class="m-d-0 d-flex">
                                Kuota {{ tagihan.wa_paket.quota }} pesan / {{ tagihan.wa_paket.masa_aktif }} hari
                            </label>
                        </div>
                    </div>
                    <div class="voucher-diskon m-d-16" v-if="tagihan.diskon">
                        <div class="d-flex-between-center">
                            <label class="m-d-0">{{ tagihan.coupon.Kode }}</label>
                            <label class="m-d-0">{{ tagihan.diskon | currency }}</label>
                        </div>
                        <div class="f-12 f-semi f-c-midgrey diskon-percent">
                            POTONGAN {{ tagihan.coupon.DiskonFitur }}%
                        </div>
                    </div>
                    <div class="separator-line m-d-16"></div>
                    <div class="biaya-admin m-d-16 d-flex-between-center">
                        <label class="m-d-0">Biaya admin</label>
                        <label class="m-d-0">{{ tagihan.biaya_admin | currency }}</label>
                    </div>
                    <div class="separator-line m-d-16"></div>
                    <div class="biaya-admin m-d-16 d-flex-between-center">
                        <label class="m-d-0 f-bold">Total pembayaran</label>
                        <label class="m-d-0">{{ tagihan.total | currency }}</label>
                    </div>
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";

import { moduleName } from "../store/state";

export default {
    name: "ModalDetailPembayaran",
    components: {
        SOSlotModal,
    },
    data() {
        return {
            backLink: "wa_autosender.pembayaran",
            modalId: "modal-detail-tagihan",
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.setBackLink(from.name);
        });
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
    },
    computed: {
        ...mapGetters(moduleName, {
            tagihan: "tagihan",
        }),
        isRegister() {
            return this.tagihan.harga_registrasi ? true : false;
        },
        jenisTagihan() {
            return this.isRegister ? "Registrasi WA Autosender" : "Ubah Paket";
        },
    },
    methods: {
        async back() {
            await this.$router.push({ name: this.backLink });
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        setBackLink(val) {
            this.backLink = val;
        },
    },
};
</script>
<style scoped>
.diskon-percent {
    padding: 2px 8px;
    border-radius: 25px;
    background-color: #ededed;
    width: fit-content;
}

.paket-wa {
    max-width: unset;
}
@media (min-width: 320px) {
    .paket-wa {
        max-width: 170px;
    }
}

@media (min-width: 360px) {
    .paket-wa {
        max-width: 210px;
    }
}

@media (min-width: 400px) {
    .paket-wa {
        max-width: 250px;
    }
}
</style>
